module.exports = __webpack_public_path__ + "static/media/ordini9.d0d4c18a.png";